import { StrictDict } from '../../utils';

export const blockTypes = StrictDict({
  html: 'html',
  video: 'video',
  problem: 'problem',
  // ADDED_EDITORS GO BELOW
  video_upload: 'video_upload',
  game: 'game',
  pdf: 'pdf',
});
